import { useTranslation } from 'react-i18next';
import { ExportIcon } from '@phosphor-icons/react';
import { ActionType } from '@/components/ActionBar';
import type { ActionConfig } from '@/components/ActionBar';
import type { GridMultiSelectionState } from '@/hooks/useGridMultiSelection';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { SelectionBar } from './SelectionBar';

interface EventsExportSelectionBarProps {
    selection: GridMultiSelectionState;
    visibleEventIds: string[];
    totalCount?: number;
    entityLabel: string;
    exportBusy: boolean;
    onExport: (eventIds: string[]) => Promise<void>;
    bulkActions: ActionConfig[];
}

export function EventsExportSelectionBar({
    selection,
    visibleEventIds,
    totalCount,
    entityLabel,
    exportBusy,
    onExport,
    bulkActions,
}: EventsExportSelectionBarProps) {
    const { t } = useTranslation(I18nNamespace.COMMON);
    const selectedVisibleIds = visibleEventIds.filter((id) =>
        selection.selectedIds.has(id),
    );
    const allSelected =
        visibleEventIds.length > 0 &&
        selectedVisibleIds.length === visibleEventIds.length;
    const exportAction: ActionConfig = {
        type: ActionType.ITEM,
        icon: ExportIcon,
        label: t('selection.export'),
        disabled: exportBusy,
        onClick: () => void onExport(selectedVisibleIds),
    };

    return (
        <SelectionBar
            selectedCount={selectedVisibleIds.length}
            totalCount={totalCount}
            entityLabel={entityLabel}
            onSelectAll={() =>
                allSelected
                    ? selection.clearSelection()
                    : selection.selectAll(visibleEventIds)
            }
            onExitMultiSelect={selection.exitMultiSelectMode}
            bulkActions={[...bulkActions, exportAction]}
        />
    );
}
